import { render, staticRenderFns } from "./FavouriteAddressItem.vue?vue&type=template&id=6e68c17b"
import script from "./FavouriteAddressItem.vue?vue&type=script&lang=js"
export * from "./FavouriteAddressItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports